export default __webpack_public_path__ + "static/media/sammal.0a48f775.jpg";